import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the education studio menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 *  ldFlags: object
 * }} params
 * @returns {object}
 */
export function getEducationStudioMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Learning',
    itemId: 'learning',
    icon: 'ribbon-fill.svg',
    path: generatePath(ROUTES.educationStudio, { businessEntityUuid }),
    order
  });
}
